/**
 * @file        src/data/worldMap.js
 * @description World-map overlay pin clusters by continent.
 *              Ported verbatim from /Neon Bookign site Design/.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */

/* World-map overlay — clusters spread across continents (label optional) */
export const WM_PINS = [
  // North America
  [12,32,'San Francisco'],[14,40,'10'],[18,30,'Seattle'],[22,40,'7'],[28,30,'Chicago'],[30,38,'Dallas'],
  [33,26,'Toronto'],[34,33,'21'],[37,35,'New York'],[38,45,'2'],[40,50,'5'],
  // South America
  [27,62,''],[29,72,'8'],[31,80,'6'],
  // Europe
  [50,24,'London'],[53,26,'34'],[55,30,'Paris'],[57,24,'18'],
  // Africa
  [52,46,''],[55,54,'9'],[53,64,'4'],
  // Asia
  [66,30,'Dubai'],[69,36,'12'],[72,32,'Mumbai'],[78,28,'Bangkok'],[82,24,'Tokyo'],[80,33,'63'],[85,30,'27'],
  // SE Asia / Oceania
  [82,52,'Singapore'],[86,58,'13'],[85,72,'Sydney'],[87,76,'5'],
];
